import React, { Component } from "react";
import { gql } from "@apollo/client";
import FileGridView from "../../FileExplorer/FileGridView/FileGridView";

import ListViewHeader from "../../ListView/ListViewHeader/ListViewHeader";
import ListViewRows from "../../ListView/ListViewRows/ListViewRows";
import FolderRoute from "../../SubHeader/SubHeader";
import ArchiveConfirmationModal from "../../Files/ArchiveConfirmationModal/ArchiveConfirmationModal";
import { apolloClient } from "../../../index";
import { notify } from "../../Notify/Notify";
import EmptyStates from "../../EmptyStates/EmptyStates";
import emptyFolderImage from "../../../assets/EmptyStates/empty_folder.svg";

export const ColumnSortingState = {
  ASC: "asc",
  DESC: "desc"
} 
class FolderListView extends Component {
  state = {
    heading: ["Files", "Added By", "Last Modified", "Shared With"],
    folderItems: this.props.subFolders,
    totalFolders: this.props.subFolders.length,
    checked: {},
    pinned: {},
    pinnedClass: " ",
    hoverId: "",
    selectAll: false,
    displayListView: true,
    isColumns: {
      isCheckbox: true,
      isTitle: true,
      isFolder: true,
      isPinned: true,
      isAddedBy: true,
      isLastModified: true,
      isShared: true,
      isDropDown: true,
      isPopover: true,
      isFoldersView: true,
    },
    tableSizeLarge: true,
    selectedColumn: "A-Z",
    showArchiveModal: false,
    archiveItemName: undefined,
    archiveItemId: "",
    searchValue: "",
    sortingValue: {column: "Files", status: ColumnSortingState.ASC},
    filterFolder: null
  };

  sortableColumns = ["Files", "Last Modified"]

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      const newCheckedObj = {};
      const checkedItems = { ...this.state.checked };
      const folderItems = [...this.state.folderItems];
      folderItems.map((folderItem) => {
        if (this.state.archiveItemName) {
          newCheckedObj[folderItem.id] = checkedItems[folderItem.id]
            ? true
            : false;
        } else {
          newCheckedObj[folderItem.id] = false;
        }
        return true;
      });

      const updatedPinned = { ...this.state.pinned };
      folderItems.map((folderItem) =>
        folderItem.pinnedFolder.length > 0
          ? (updatedPinned[folderItem.id] = true)
          : (updatedPinned[folderItem.id] = false)
      );

      let subFolderItems = [...this.props.subFolders];

      this.setState({
        pinned: updatedPinned,
        folderItems: subFolderItems,
        totalFolders: subFolderItems.length,
        checked: newCheckedObj,
        selectAll:
          this.state.archiveItemName && this.state.selectAll ? true : false,
      });
    }
  }

  componentDidMount() {
    const variables = {
      first: 0,
    };

    apolloClient
      .query({
        query: gql`
          query PinFolders($first: Int!) {
            pinFolders(first: $first, skip: 0) {
              id
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        const pinFolders = result.data.pinFolders.map(
          (pinFolder) => pinFolder.id
        );

        let pinnedFolder = {};
        let checkedFolder = {};
        this.state.folderItems.map((rpKey) => {
          pinnedFolder[rpKey.folderId] = pinFolders.includes(rpKey.folderId)
            ? true
            : false;
          checkedFolder[rpKey.folderId] = false;
          return true;
        });

        this.setState({ pinned: pinnedFolder, checked: checkedFolder });
      })
      .catch((e) => {
        const detail = "Error";
        const title = e.message;
        const type = "error";
        notify(detail, title, type);
      });
  }

  totalChecked = () => {
    let selectedFolder = 0;
    Object.keys(this.state.checked).map((cKey) =>
      this.state.checked[cKey] ? (selectedFolder += 1) : null
    );
    return selectedFolder;
  };

  getIntials = (name) => {
    let intial_arr = name.split(" ");
    let intials = intial_arr[0][0] + intial_arr[1][0];
    return intials;
  };

  displayListHandler = () => {
    let updatedDisplayView = this.state.displayListView;
    updatedDisplayView = true;
    this.setState({ displayListView: updatedDisplayView });
  };

  displayGridtHandler = () => {
    let updatedDisplayView = this.state.displayListView;
    updatedDisplayView = false;
    this.setState({ displayListView: updatedDisplayView });
  };

  pinOverHandler = (id) => {
    this.setState({ hoverId: id });
  };

  pinOutHandler = (id) => {
    this.setState({ hoverId: "" });
  };

  pinHandler = (id, checkPin, folderTitle, parentId) => {
    const variables = {
      folderId: id,
    };
    let PIN_API = checkPin
      ? `mutation UnPinFolder($folderId: UUID!) {
          unPinFolder(folderId: $folderId) {
            success
          }
        }`
      : `mutation PinFolder($folderId: UUID!) {
          pinFolder(folderId: $folderId) {
            success
          }
        }`;

    apolloClient
      .mutate({
        mutation: gql`
          ${PIN_API}
        `,
        variables: variables,
      })
      .then((result) => {
        let pinnedItem = this.state.pinned;
        pinnedItem[id] = !this.state.pinned[id];
        this.setState({ pinned: pinnedItem });
        // update pin sidebr--->

        const rootFolders = [...this.props.rootFolders];
        const subFolders = { ...this.props.objSubFolders };

        subFolders[parentId].map((sub) => {
          if (sub.id === id) {
            if (sub.pinnedFolder.length === 0) {
              sub.pinnedFolder.push({
                folder: {
                  id: id,
                  title: folderTitle,
                },
                user: {
                  id: this.props.currentUserInfo.id,
                },
              });
            } else {
              sub.pinnedFolder = [];
            }
          }
          return true;
        });
        this.props.updateFolders({
          rootFolders: rootFolders,
          subFolders: subFolders,
        });
        // }

        // notify on success
        const detail = "Success";
        const title = checkPin
          ? `${folderTitle} unpinned successfully!`
          : `${folderTitle} Folder pinned successfully!`;
        const type = "success";
        notify(detail, title, type);
      })
      .catch((e) => {
        // notify for error
        const detail = "Error";
        const title = e.message;
        const type = "error";
        notify(detail, title, type);
      });
  };

  checkHandler = (id) => {
    let checkedItem = this.state.checked;
    checkedItem[id] = !checkedItem[id];
    let count = 0;
    for (let value of Object.values(checkedItem)) {
      !value && count++;
    }
    this.setState({ checked: checkedItem, selectAll: count === 0 });
  };

  selectAllHandler = () => {
    let checkedFolders = this.state.checked;
    Object.keys(checkedFolders).map(
      (sKey) => (checkedFolders[sKey] = this.state.selectAll ? false : true)
    );

    this.setState({
      checked: checkedFolders,
      selectAll: !this.state.selectAll,
    });
  };

  unselectAllHandler = () => {
    let checkedFolders = this.state.checked;

    Object.keys(checkedFolders).map((sKey) => (checkedFolders[sKey] = false));

    this.setState({ checked: checkedFolders, selectAll: false });
  };

  setArchiveModalVisibility = (show, itemName = undefined, itemId = "") => {
    this.setState({
      showArchiveModal: show,
      archiveItemName: itemName,
      archiveItemId: itemId,
    });
  };

  sortColumnHandler = ({ column, status } = this.state.sortingValue) => {
    if (this.sortableColumns.includes(column)) {
      this.setState(
        {
          sortingValue: { column, status },
        },
        () => this.getFilteredData()
      );
    }
  };

  archiveFolder = (date) => {
    const totalCheck = this.totalChecked();
    if (totalCheck === 0) {
      const totalDays = this.props.getTotalDays(date);
      const variables = {
        folders: [this.state.archiveItemId],
        archivedTill: totalDays,
      };
      apolloClient
        .mutate({
          mutation: gql`
            mutation ArchiveFolders($folders: [UUID], $archivedTill: Int!) {
              archiveFolders(folders: $folders, archivedTill: $archivedTill) {
                success
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {
          let newSubArr = this.state.folderItems;
          const subFilterArr = newSubArr.filter(
            (sub) => sub.id !== this.state.archiveItemId
          );
          this.props.setSubfolders(subFilterArr);
          this.setState({
            showArchiveModal: false,
            folderItems: subFilterArr,
          });
          const detail = "Success";
          const title = `${this.state.archiveItemName} archived successfully!`;
          const type = "success";
          notify(detail, title, type);
        })
        .catch((e) => {
          const detail = "Error";
          const title = e.message;
          const type = "error";
          notify(detail, title, type);
        });
    } else {
      if (this.state.archiveItemId.length > 0) {
        const totalDays = this.props.getTotalDays(date);
        const variables = {
          folders: [this.state.archiveItemId],
          archivedTill: totalDays,
        };
        apolloClient
          .mutate({
            mutation: gql`
              mutation ArchiveFolders($folders: [UUID], $archivedTill: Int!) {
                archiveFolders(folders: $folders, archivedTill: $archivedTill) {
                  success
                }
              }
            `,
            variables: variables,
          })
          .then((result) => {
            let newSubArr = this.state.folderItems;
            const subFilterArr = newSubArr.filter(
              (sub) => sub.id !== this.state.archiveItemId
            );
            this.props.setSubfolders(subFilterArr);

            const detail = "Success";
            const title = `${this.state.archiveItemName} archived successfully!`;
            const type = "success";
            notify(detail, title, type);

            // set checked subfolders
            const checkedItems = { ...this.state.checked };
            delete checkedItems[this.state.archiveItemId];
            this.setState({
              showArchiveModal: false,
              folderItems: subFilterArr,
              checked: checkedItems,
              archiveItemId: "",
              archiveItemName: undefined,
            });
          })
          .catch((e) => {
            const detail = "Error";
            const title = e.message;
            const type = "error";
            notify(detail, title, type);
          });
      } else {
        const totalDays = this.props.getTotalDays(date);
        const checkedArr = [];
        const newCheckedObj = {};
        for (const [key, value] of Object.entries(this.state.checked)) {
          value ? checkedArr.push(key) : (newCheckedObj[key] = value);
        }

        const variables = {
          folders: checkedArr,
          archivedTill: totalDays,
        };
        apolloClient
          .mutate({
            mutation: gql`
              mutation ArchiveFolders($folders: [UUID], $archivedTill: Int!) {
                archiveFolders(folders: $folders, archivedTill: $archivedTill) {
                  success
                }
              }
            `,
            variables: variables,
          })
          .then((result) => {
            let newArr = [...this.state.folderItems];
            const filterArr = newArr.filter(
              (folderItem) => !checkedArr.includes(folderItem.folderId)
            );
            this.props.setSubfolders(filterArr);
            this.setState({
              showArchiveModal: false,
              selectAll: false,
              folderItems: filterArr,
              checked: newCheckedObj,
            });
            const detail = "Success";
            const title = "All folders have been successfully archived";
            const type = "success";
            notify(detail, title, type);
          })
          .catch((e) => {
            const detail = "Error";
            const title = e.message;
            const type = "error";
            notify(detail, title, type);
          });
      }
    }
  };

  handleSelectArchive = () => {
    this.setState({ showArchiveModal: true });
  };

  handleSelectShare = () => {
    const numCheck = this.totalChecked();
    this.props.setShareFolders(this.state.checked, numCheck);
  };

  filterApplyHandler = (data) => {
    this.setState(
      {
        filterFolder: data.Folder || [],
      },
      () => this.getFilteredData()
    );
  };

  setSearchFilter = (value) => {
    this.setState(
      {
        searchValue: value,
      },
      () => this.getFilteredData()
    );
  }

  getFilteredData = () => {
    const { searchValue, sortingValue, filterFolder } = this.state;
    const { status, column } = sortingValue;

    let filteredFolderItems = [...this.props.subFolders];

    if (filterFolder && filterFolder.length > 0) {
      filteredFolderItems = filteredFolderItems.filter((item) => filterFolder.find((title) => title === item.title));
    }

    if (searchValue !== "") {
      filteredFolderItems = filteredFolderItems.filter((subfolder) =>
        subfolder.title.toLowerCase().includes(searchValue.trim().toLowerCase())
      );
    }

    if (column === "Files") {
      if (status === ColumnSortingState.ASC) {
        filteredFolderItems = filteredFolderItems.sort((a, b) =>
          a.title.toLowerCase() > b.title.toLowerCase() ? 1 : a.title.toLowerCase() < b.title.toLowerCase() ? -1 : 0
        );
      } else {
        filteredFolderItems = filteredFolderItems.sort((a, b) =>
          a.title.toLowerCase() > b.title.toLowerCase() ? -1 : a.title.toLowerCase() < b.title.toLowerCase() ? 1 : 0
        );
      }
    } else if (column === "Last Modified") {
      if (status === ColumnSortingState.ASC) {
        filteredFolderItems = filteredFolderItems.sort((a, b) => new Date(b.modifiedTs) - new Date(a.modifiedTs));
      } else {
        filteredFolderItems = filteredFolderItems.sort((a, b) => new Date(a.modifiedTs) - new Date(b.modifiedTs));
      }
    } else {
      filteredFolderItems = filteredFolderItems.sort((a, b) => (a.title > b.title ? 1 : -1));
    }
    this.setState({
      folderItems: filteredFolderItems,
      totalFolders: filteredFolderItems.length,
    });
  }

  render() {
    return (
      <div>
        <ArchiveConfirmationModal
          showModal={this.state.showArchiveModal}
          numberOfFiles={this.totalChecked()}
          archiveItemName={this.state.archiveItemName}
          handleYesClick={(date) => {
            this.archiveFolder(date);
          }}
          handleNoClick={() => {
            this.setArchiveModalVisibility(false);
          }}
        />
        <div className="row">
          <FolderRoute
            displayGridtHandler={this.displayGridtHandler}
            displayListHandler={this.displayListHandler}
            totalChecked={this.totalChecked}
            checkedItems={this.state.checked}
            setArchiveModalVisibility={this.setArchiveModalVisibility}
            unselectAllHandler={this.unselectAllHandler}
            isFoldersView={this.state.isColumns.isFoldersView}
            displayListView={this.state.displayListView}
            checked={this.state.selectAll}
            selectAllHandler={this.selectAllHandler}
            sortColumnHandler={this.sortColumnHandler}
            selectedColumn={this.state.selectedColumn}
            handleShare={this.handleSelectShare}
            handleArchive={this.handleSelectArchive}
            filterApplyHandler={this.filterApplyHandler}
            searchValue={this.state.searchValue}
            setSearchValue={this.setSearchFilter}
            searchPlaceholder="&#xF002;  Search folders"
            {...this.props}
          />
        </div>
        <div className="row">
          <div
            className={
              this.state.displayListView ? "d-block col" : "d-none col"
            }
          > 
            {this.state.folderItems.length > 0 ? (
              <div className="table-responsive folder-list">
                {/* Table header */}
                <table className="table table-hover">
                  <thead>
                    <tr className="folderlist-header table-borderless">
                      {this.state.heading.map((headKey) => (
                        <ListViewHeader
                          key={headKey}
                          columnName={headKey}
                          count={this.state.totalFolders}
                          checked={this.state.selectAll}
                          selectAllHandler={this.selectAllHandler}
                          isCheckbox={this.state.isColumns.isCheckbox}
                          isFolder={true}
                          sortingValue={this.state.sortingValue}
                          sortColumnHandler={this.sortColumnHandler}
                        />
                      ))}
                      {/* For action column */}
                      <td></td>
                    </tr>
                  </thead>

                  {/* Table Rows */}
                  <tbody>
                    {this.state.folderItems.map((rKey, index) => (
                      <ListViewRows
                        key={index}
                        item={rKey}
                        checkPin={this.state.pinned[rKey.folderId]}
                        pinHandler={this.pinHandler}
                        pinOverHandler={this.pinOverHandler}
                        pinOutHandler={this.pinOutHandler}
                        pinnedClass={this.state.pinnedClass}
                        hoverId={this.state.hoverId}
                        checkHandler={this.checkHandler}
                        setArchiveModalVisibility={this.setArchiveModalVisibility}
                        checked={this.state.checked[rKey.folderId]}
                        selectAllChecked={this.state.selectAll}
                        isColumns={this.state.isColumns}
                        size={this.state.tableSizeLarge}
                        isFolder={true}
                        rootFolderId={
                          rKey["__typename"] === "FolderType"
                            ? rKey.parentFolder
                              ? rKey.parentFolder.id
                              : rKey.folderId
                            : rKey.__typename === "DocumentType"
                            ? rKey.folder.parentFolder.id
                            : null
                        }
                        subFolderId={
                          "parentFolder" in rKey ? rKey.folderId : rKey.folder.id
                        }
                        subFolderUpdate={this.props.setEditFolder}
                        {...this.props}
                      />
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="col is-size-h2 bold no-searched-folders">
                <EmptyStates
                  imgSrc={emptyFolderImage}
                  emptyStateTitle="No results found !"
                  description="Please try again using different filters or search terms"
                  emptyStateButtons={[]}
                  {...this.props}
                />
              </div>
            )}
            
          </div>
          <div
            className={
              this.state.displayListView ? "d-none col" : "d-block col"
            }
          >
            <FileGridView
              fileItems={this.state.folderItems}
              pinned={this.state.pinned}
              checked={this.state.checked}
              checkHandler={this.checkHandler}
              pinHandler={this.pinHandler}
              pinOverHandler={this.pinOverHandler}
              pinOutHandler={this.pinOutHandler}
              setArchiveModalVisibility={this.setArchiveModalVisibility}
              isColumns={this.state.isColumns}
              isFolder={true}
              hoverId={this.state.hoverId}
              {...this.props}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default FolderListView;
